import {yupResolver} from "@hookform/resolvers/yup";
import {Button, Stack, TextField, Autocomplete} from "@mui/material";
import {useForm, Controller} from "react-hook-form";
import * as yup from "yup";
import {useNavigate} from "react-router-dom";
import useApiRequest from "../../hooks/useApiRequest";
import {snackbar} from "../../utils/snackbar";
import {useEffect, useState} from "react";

const schema = yup.object().shape({
  name: yup
    .string()
    .required("El nombre es obligatorio")
    .max(255, "Máximo 255 caracteres")
    .matches(/^[a-zA-Z0-9. ]*$/, "Solo se permiten letras, números y puntos"),
  description: yup.string().required("La descripción es obligatoria").max(255, "Máximo 255 caracteres"),
  product: yup.mixed().nullable()
});

const RoleForm = ({isNew, refreshData, setIsEditing, initialRoleData}) => {
  const navigate = useNavigate();
  const {loading, update, create} = useApiRequest({baseUrl: `/roles`, resource: "roles"});
  const {makeRequest} = useApiRequest({baseUrl: `/products`, resource: "products"});

  const [productOptions, setProductOptions] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const result = await makeRequest("get", "");

      if (result?.data?.data) {
        const mapped = result.data.data.map((p) => ({id: p.id, label: p.name || p.id, ...p}));
        setProductOptions(mapped);
      }
    };
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = async (data) => {
    const productIdValue = data.product?.id ?? null;

    const submitData = {
      name: data.name,
      description: data.description,
      ...(productIdValue && {product_id: productIdValue})
    };

    const {success} = isNew ? await create(submitData) : await update(initialRoleData.id, submitData);
    if (!success) return;

    if (isNew) {
      snackbar.success("Rol creado correctamente.");
      navigate("/roles");
      return;
    }

    snackbar.success("Rol actualizado correctamente.");
    refreshData();
    setIsEditing(false);
  };

  const {
    register,
    handleSubmit,
    formState: {errors},
    control
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: initialRoleData?.name || "",
      description: initialRoleData?.description || "",
      product: initialRoleData?.product || null
    }
  });

  const onSubmit = (data) => {
    handleSave(data);
  };

  return (
    <Stack direction="column" spacing={2} minWidth={"300px"}>
      <TextField
        label="Nombre"
        {...register("name")}
        multiline
        slotProps={{htmlInput: {maxLength: 255}}}
        error={!!errors.name}
        helperText={errors.name?.message}
        variant="outlined"
      />
      <TextField
        label="Descripción"
        {...register("description")}
        multiline
        slotProps={{htmlInput: {maxLength: 255}}}
        error={!!errors.description}
        helperText={errors.description?.message}
        variant="outlined"
      />
      <Controller
        name="product"
        control={control}
        render={({field}) => (
          <Autocomplete
            {...field}
            options={productOptions}
            getOptionLabel={(option) => option?.label || ""}
            onChange={(_, value) => field.onChange(value)}
            disableCloseOnSelect={false}
            autoHighlight
            renderInput={(params) => (
              <TextField
                {...params}
                label="Producto (Opcional)"
                error={!!errors.product}
                helperText={errors.product?.message}
                variant="outlined"
              />
            )}
          />
        )}
      />
      <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)} disabled={loading}>
        {isNew ? "Crear" : "Guardar"}
      </Button>
    </Stack>
  );
};

export default RoleForm;
